import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgStyle } from '@angular/common';
import { ThemePipe } from '../../../../core/pipes/theme.pipe';
import { PlaybackButtonComponent } from '../playback-button/playback-button.component';
import {
  ReplayProgressComponent,
  ReplayProgressEvent,
} from '../replay-progress/replay-progress.component';

@Component({
  selector: 'app-replay-game-controls-view',
  templateUrl: './replay-game-controls-view.component.html',
  styleUrls: ['./replay-game-controls-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReplayProgressComponent, PlaybackButtonComponent, NgStyle, ThemePipe],
})
export class ReplayGameControlsViewComponent {
  // Where playback is on the timeline: the current segment and how far through it (0–100).
  readonly progressEvent = input.required<ReplayProgressEvent>();
  readonly totalSegments = input.required<number>();
  // 'play' while paused, 'pause' while playing.
  readonly playIcon = input.required<string>();
  // The current speed's label ("1x").
  readonly playbackSpeed = input.required<string>();
  readonly playClickedEvent = output<void>();
  readonly skipBackClickedEvent = output<void>();
  readonly skipForwardClickedEvent = output<void>();
  readonly playbackSpeedClickedEvent = output<void>();

  readonly labelStyles: [string, string][] = [
    ['type', 'replay-playback-speed'],
    ['text-color', 'replay-playback-icon'],
  ];

  playClick(): void {
    this.playClickedEvent.emit();
  }

  skipBackClick(): void {
    this.skipBackClickedEvent.emit();
  }

  skipForwardClick(): void {
    this.skipForwardClickedEvent.emit();
  }

  playbackSpeedClick(): void {
    this.playbackSpeedClickedEvent.emit();
  }
}
